import { IconCancel } from "@tabler/icons-react";

export const AiImageFeatureDisabled = () => {
  return (
    <div className="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center">
      <div className="tw-bg-white tw-outline tw-outline-1 tw-outline-solid tw-outline-blue/5 tw-rounded-xl tw-shadow-sm tw-px-10 tw-py-6 tw-flex tw-flex-col tw-items-center tw-justify-center">
        <div className="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center">
          <IconCancel className="tw-size-6" />
          <div className="tw-flex tw-flex-col tw-gap-1 tw-items-center tw-text-center tw-text-blue">
            <p className="tw-font-medium tw-text-base tw-leading-6 tw-m-0">
              Feature Disabled
            </p>
            <p className="tw-font-normal tw-text-sm tw-leading-5 tw-m-0">
              Generating images with AI was
              <br />
              disabled by your account admin
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
